<template>
  <div class="bs-wrapper">
    <van-tabs v-model="active" title-active-color="#FF6F00" title-inactive-color="#333333" @click="onClick">
      <van-tab title="员工餐"></van-tab>
      <van-tab title="内购会"></van-tab>
    </van-tabs>
    <!-- 列表 -->
    <InsideList :type="active"/>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import InsideList from '@/views/PlazaActivity/InsideList'
// import bridge_handler from '@utils/bridge';

export default {
  name: 'plazaActivityInside',

  mixins: [],

  components:{
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    InsideList
  },

  props:{},

  data(){
    return {
      active:1
    }
  },

  computed:{},

  watch:{},

  created(){
    this.active = this.$route.query.type?(this.$route.query.type=='discount'?1:0):0
  },

  mounted(){},

  destroyed(){},

  methods:{
    onClick(name) {
      let nameArr = ['food','discount']
      this.$router.replace({name:'plazaActivityInside',query:{type:nameArr[name]}})
    },
  },

  beforeRouteEnter(t, f, next) {
    // bridge_handler.isShowOrHiddenRightBtn({isShow: '0'})
    next()
  },

}
</script>

<style lang="less" scoped>

</style>
